// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const OutOfStock: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13">
            <path
                fill="#E4104E"
                d="M6 .5a6 6 0 1 0 0 12 6 6 0 1 0 0-12Zm2.491 8.074a.563.563 0 0 1-.858.727L6 7.37l-1.634 1.93c-.11.131-.27.199-.45.199a.563.563 0 0 1-.408-.926L5.264 6.5 3.51 4.426a.561.561 0 1 1 .857-.727L6 5.63l1.633-1.93a.562.562 0 1 1 .86.726L6.735 6.5 8.49 8.574Z"
                opacity=".66"
            />
        </svg>
    );
};

export default React.memo(OutOfStock);
